export default "__VITE_ASSET__Dk_5FrhQ__"